import Physician from "../../../assets/markers/physician.png";
import Clinic from "../../../assets/markers/clinic.png";
import Hospital from "../../../assets/markers/hospital.png";
import Nfp from "../../../assets/markers/nfp.png";
import Ohcp from "../../../assets/markers/ohcp.png";
import Dovebiz from "../../../assets/markers/dovebiz.png";
import User from "../../../assets/markers/user.png";
import { MarkerInterface } from "../../../types";


export const backgroundColorPicker = (
  isPremium?: boolean, 
  isRecommended?: boolean, 
  isClaimed?: boolean
) => {
  return isPremium 
    ? '#F5A623' 
    : isRecommended 
      ? '#906EFF' 
      : isClaimed 
        ? '#00C853' 
        : '#2A71D4'
}

export const pickUserIcon = (itemType?: string) => {
  const value = itemType ? itemType.toLocaleLowerCase() : itemType;
  switch (value) {
    case 'physician':
      return Physician
    case 'clinic':
      return Clinic
    case 'hospital':
      return Hospital
    case 'ohcp':
      return Ohcp
    case 'nfp':
      return Nfp
    case 'business':
      return Dovebiz
    default:
      return User
  }
}

export const iconHtml = ({ data, active = false }: { data: MarkerInterface, active?: boolean }) => {
  const { count, data: details } = data;
  const { picture, extraFilters, itemType } = details || {};
  const { isPremium, isRecommended, isClaimed } = extraFilters || {};
  return `
    <div
      style="
      position: relative; 
      border-radius: 50%; 
      width: ${(active) ? '60px' : '40px'};
      height: ${(active) ? '60px' : '40px'};
      padding: 8px;
      border: 2px solid #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 700;
      color: #FFFFFF;
      z-index: 1000;
      background-color: ${backgroundColorPicker(isPremium, isRecommended, isClaimed)}; 
      box-shadow: ${(picture) ? '0 0 0 2px' + backgroundColorPicker(isPremium, isRecommended, isClaimed) : 'none'};
      "
    >
      ${count <= 1
        ? 
          `
            <img 
              src=${picture ? picture : pickUserIcon(itemType)} 
              style="
                width: ${picture ? '100%' : '14px'};
                height: ${picture ? '100%' : 'auto'};
                filter: ${(picture) ? 'none' : 'brightness(0) invert(1)'};
                border-radius: ${picture ? '50%' : '0'};
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                object-fit: cover;
                " 
              />
          `
        : `<span>${count > 1000 ? '+1000' : count}</span>`
      }
    </div>
    `
}
